import React, { Component } from "react";
import LoginModal from "./LoginModal.jsx";
import { Nav, NavDropdown, MenuItem, Button } from 'react-bootstrap';
import axios from "axios";
import serialize from "form-serialize";
import hyperlinks from "../../../src/util/hyperlinks";
import Functions from "../../../src/util/functions";



export default class LoginContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            errorMessage: ""
        };
        this.handleLoginClick = this.handleLoginClick.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleLogOut = this.handleLogOut.bind(this);
        this.handleLoginSubmit = this.handleLoginSubmit.bind(this);
    }

    handleLoginClick() {
        this.setState({ showModal: true, errorMessage: "" });
    }

    closeModal() {
        this.setState({ showModal: false });
    }

    handleLogOut() {
        axios.delete("/users/sign_out", { params: { authenticity_token: Functions.getMetaContent("csrf-token") } })
            .then(res => {
                location.reload();
            })
            .catch(err => {
                console.error(err);
                location.reload();
            });
    }

    handleLoginSubmit(e) {
        e.preventDefault();

        const form = e.target.closest("form");
        axios.post(form.action, serialize(form))
            .then(() => {
                window.location.reload();
            })
            .catch(err => {
                this.setState({ errorMessage: err.request.responseText });
            });
    }

    render() {
        let loginBoxContent;
        let newMessageNotification;
        if (this.props.currentUser) {
            loginBoxContent = (
                <Nav>
                    <NavDropdown eventKey={10} title={this.props.currentUser.first_name} id="login-dropdown">
                        <MenuItem eventKey={10.1} href={hyperlinks["yourAccount"]}>Your account</MenuItem>
                        <MenuItem eventKey={10.2} href="https://leading-utilities-of-the-world-network.mn.co/sign_in?from=https%3A%2F%2Fleading-utilities-of-the-world-network.mn.co%2Ffeed" target="_blank">Messages</MenuItem>
                        <MenuItem divider />
                        <MenuItem eventKey={10.3} onClick={this.handleLogOut}>Log out</MenuItem>
                    </NavDropdown>
                </Nav>
            );

            if (this.props.currentUser.user_channels.some(userChannel => userChannel.unread_message_count > 0)) {
                newMessageNotification = <img className="notification" src="/assets/notification-bell-d4f3828feb3630b9cb4f5119c4f49e815161e99e090ce5c1495572217d496144.png" />;
            }
        } else {
            loginBoxContent = (
                <a href="https://leading-utilities-of-the-world-network.mn.co/sign_in?from=https%3A%2F%2Fleading-utilities-of-the-world-network.mn.co%2Ffeed" target="_blank">
                    <Button>Member Log in</Button>
                </a>
            );
        }

        return (
            <div className="login-box">
                {loginBoxContent}
                {newMessageNotification}
                <LoginModal handleLoginSubmit={this.handleLoginSubmit} errorMessage={this.state.errorMessage} showModal={this.state.showModal} closeModal={this.closeModal} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/LoginContainer.jsx.erb